import React from 'react';

const integrationTypes = ['ALL', 'PAYMENT_GATEWAY', 'ROUTER_VENDOR', 'OLT_VENDOR', 'WHATSAPP_PROVIDER', 'CRM', 'ERP', 'OSS_PARTNER', 'CUSTOM'];
const statuses = ['ALL', 'ACTIVE', 'INACTIVE', 'DISABLED', 'REVOKED', 'FAILED'];
const eventTypes = [
  'ALL',
  'billing.invoice.created',
  'billing.payment.success',
  'ticket.created',
  'ticket.updated',
  'monitoring.incident.created',
  'monitoring.incident.resolved',
  'provisioning.customer.created',
  'provisioning.activation.success',
];
const scopes = [
  'ALL',
  'customers.read',
  'tickets.read',
  'tickets.write',
  'billing.read',
  'billing.write',
  'notifications.read',
  'monitoring.read',
  'provisioning.write',
  'webhooks.manage',
];

const OpenPlatformFilterBar = ({ filters, onChange, onRefresh }) => {
  const set = (key, value) => onChange((prev) => ({ ...prev, [key]: value }));

  return (
    <div className="grid gap-3 rounded-lg border border-slate-800 bg-slate-900/60 p-3 md:grid-cols-5">
      <label className="text-xs text-slate-300">
        Status
        <select value={filters.status} onChange={(e) => set('status', e.target.value)} className="mt-1 w-full rounded border border-slate-700 bg-slate-950 px-2 py-2 text-xs text-slate-100">
          {statuses.map((item) => <option key={item} value={item}>{item}</option>)}
        </select>
      </label>
      <label className="text-xs text-slate-300">
        Tipe Integrasi
        <select value={filters.integrationType} onChange={(e) => set('integrationType', e.target.value)} className="mt-1 w-full rounded border border-slate-700 bg-slate-950 px-2 py-2 text-xs text-slate-100">
          {integrationTypes.map((item) => <option key={item} value={item}>{item}</option>)}
        </select>
      </label>
      <label className="text-xs text-slate-300">
        Event Webhook
        <select value={filters.eventType} onChange={(e) => set('eventType', e.target.value)} className="mt-1 w-full rounded border border-slate-700 bg-slate-950 px-2 py-2 text-xs text-slate-100">
          {eventTypes.map((item) => <option key={item} value={item}>{item}</option>)}
        </select>
      </label>
      <label className="text-xs text-slate-300">
        Scope API
        <select value={filters.scope} onChange={(e) => set('scope', e.target.value)} className="mt-1 w-full rounded border border-slate-700 bg-slate-950 px-2 py-2 text-xs text-slate-100">
          {scopes.map((item) => <option key={item} value={item}>{item}</option>)}
        </select>
      </label>
      <div className="flex items-end">
        <button type="button" onClick={onRefresh} className="w-full rounded border border-cyan-400/40 bg-cyan-500/10 px-3 py-2 text-xs font-semibold text-cyan-200 hover:bg-cyan-500/20">
          Refresh
        </button>
      </div>
    </div>
  );
};

export default OpenPlatformFilterBar;
